import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {catchError, switchMap} from 'rxjs/operators';
import {from, of} from 'rxjs';
import {LoadError} from '@app/core/store/actions/error.actions';
import {ShiftTemplateService} from '@app/core/services/api/shift-template.service';
import {getCurrentState} from '@app/core/helpers';
import {IAppState} from '@app/core/store/state/app.state';
import {Store} from '@ngrx/store';
import {
	CreateShiftTemplate,
	CreateShiftTemplateSuccess,
	DeleteShiftTemplate,
	DeleteShiftTemplateSuccess,
	EShiftTemplatesActions,
	GetTemplates,
	GetTemplatesSuccess,
	InsertShiftTemplate,
	InsertShiftTemplateSuccess,
	PostCopyingWeek,
	PostCopyingWeekSuccess
} from '@app/core/store/actions/shift-templates.actions';
import {GetShifts} from '@app/core/store/actions/schedule.actions';
import {ShiftTemplate} from '@app/core/models/shift-template.model';

@Injectable()
export class ShiftTemplatesEffects {

	@Effect()
	public onGetTemplates$ = this.actions$.pipe(
		ofType<GetTemplates>(EShiftTemplatesActions.GetTemplates),
		switchMap((action: GetTemplates) => from(this.shiftTemplateService.getTemplates(action.departmentId)).pipe(
			switchMap((shiftTemplates: any[]) => [
				new GetTemplatesSuccess(shiftTemplates),
			]),
			catchError(error => of(new LoadError(error, action))),
		)),
	);
	@Effect()
	public onPostCopyingWeek$ = this.actions$.pipe(
		ofType<PostCopyingWeek>(EShiftTemplatesActions.PostCopyingWeek),
		switchMap((action: PostCopyingWeek) => from(this.shiftTemplateService.postWeek(action.copyingWeek, action.startDate, getCurrentState(this.store).shiftDrafts.selectedShiftDraft)).pipe(
			switchMap(() => [
				new PostCopyingWeekSuccess(),
				new GetShifts(
					getCurrentState(this.store).schedule.selectedDates[0],
					getCurrentState(this.store).schedule.selectedDates[getCurrentState(this.store).schedule.selectedDates.length - 1]
				)
			]),
			catchError(error => of(new LoadError(error, action))),
		)),
	);
	@Effect()
	public onCreateShiftTemplate$ = this.actions$.pipe(
		ofType<CreateShiftTemplate>(EShiftTemplatesActions.CreateShiftTemplate),
		switchMap((action: CreateShiftTemplate) => from(this.shiftTemplateService.create(action.shiftTemplate, action.departmentId)).pipe(
			switchMap((data: { template: ShiftTemplate }) => [
				new CreateShiftTemplateSuccess(data.template),
			]),
			catchError(error => of(new LoadError(error, action))),
		)),
	);
	@Effect()
	public onDeleteShiftTemplate$ = this.actions$.pipe(
		ofType<DeleteShiftTemplate>(EShiftTemplatesActions.DeleteShiftTemplate),
		switchMap((action: DeleteShiftTemplate) => from(this.shiftTemplateService.delete(action.shiftTemplateId)).pipe(
			switchMap(() => [
				new DeleteShiftTemplateSuccess(action.shiftTemplateId),
			]),
			catchError(error => of(new LoadError(error, action))),
		)),
	);
	@Effect()
	public onInsertShiftTemplate$ = this.actions$.pipe(
		ofType<InsertShiftTemplate>(EShiftTemplatesActions.InsertShiftTemplate),
		switchMap((action: InsertShiftTemplate) => from(this.shiftTemplateService.insert(action.shiftTemplate, action.startDate, getCurrentState(this.store).shiftDrafts.selectedShiftDraft)).pipe(
			switchMap(() => [
				new InsertShiftTemplateSuccess(),
			]),
			catchError(error => of(new LoadError(error, action))),
		)),
	);

	@Effect()
	public onInsertShiftTemplateSuccess$ = this.actions$.pipe(
		ofType<InsertShiftTemplateSuccess>(EShiftTemplatesActions.InsertShiftTemplateSuccess),
		switchMap(() => [
			new GetShifts(
				getCurrentState(this.store).schedule.selectedDates[0],
				getCurrentState(this.store).schedule.selectedDates[getCurrentState(this.store).schedule.selectedDates.length - 1]
			)
		])
	);

	constructor(
		private actions$: Actions,
		private store: Store<IAppState>,
		private shiftTemplateService: ShiftTemplateService
	) {
	}
}
